export const tokens = {
    zeus_token: 'ZEUS_TOKEN',
    proxy_user_token: '5b7b001172be31857a6da406b30f3c5528a0ab62',
    proxy_user_sparrc_morphle_admin: 'MORPHLE_SPARRC_ADMIN_TOKEN',
    proxy_user_uscap: '617f72f6baf2fdc3f9b253979c11f7403248272e',
	proxy_user_website: '50ba6d8672a60f3474cc1c1cb992633ecb38d666',
}

